import { useMaskStore } from '@/stores/mask-store'
import { maskEmail, maskPhone, maskName } from '@/lib/utils/mask'
import type { ReactNode } from 'react'

type MaskType = 'email' | 'phone' | 'name'

interface MaskedTextProps {
  value: string | undefined | null
  type: MaskType
  className?: string
  fallback?: ReactNode
}

export function MaskedText({
  value,
  type,
  className = '',
  fallback = null,
}: MaskedTextProps) {
  const { isMasked } = useMaskStore()

  if (!value) {
    return <>{fallback}</>
  }

  let displayValue = value
  if (isMasked) {
    switch (type) {
      case 'email':
        displayValue = maskEmail(value)
        break
      case 'phone':
        displayValue = maskPhone(value)
        break
      case 'name':
        displayValue = maskName(value)
        break
    }
  }

  return <span className={className}>{displayValue}</span>
}
